import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggedUserService } from '../services/logged-user.service';

/**
 * Guard that only allows access to the error page if there's an actual load error.
 * Prevents direct navigation to /error.
 */
export const errorPageGuard: CanActivateFn = () => {
  const loggedUserService = inject(LoggedUserService);
  const router = inject(Router);

  if (loggedUserService.hasLoadError) {
    return true;
  }

  // Redirect to home if trying to access error page without an actual error
  return router.createUrlTree(['/']);
};
